"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
exports.config = {
    // default will not sort the object key
    sort_key: false,
    // default will convert into null silently like JSON.stringify
    error_on_nan: false,
    error_on_infinite: false,
};
